import type { ReactNode } from 'react';
import { Text } from '@customerio/pluma-components/react';

interface SectionLabelProps {
  children: ReactNode;
}

export function SectionLabel({ children }: SectionLabelProps) {
  return (
    <Text as="div" size="s" weight="semibold" color="subtle">
      {children}
    </Text>
  );
}
